export const journeyMake = 'make';
export const journeyType = 'type';
export const journeyBudget = 'budget';
export const filterMake = 'make';
export const filterRange = 'range';
export const filterModel = 'model';
export const filterPriceFrom = 'priceFrom';
export const filterPriceTo = 'priceTo';
export const filterStatus = 'status';